import { search } from "./search";
import { filters } from "./filters";

export const planos = {
    namespaced: true,
    modules: {
        search,
        filters
    }
};



// WEBPACK FOOTER //
// ./src/store/planos/planos.js